import { useLayoutEffect, useRef } from 'react'
import { Trans } from 'react-i18next'

import { useGSAP } from '@/composables/useGSAP'
import { useTransComponents } from '@/composables/useTransComponents'

export type UITextProps = React.HTMLProps<HTMLDivElement> & {
  is: 'p' | 'span' | 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'li'
  i18nKey: string
  delay?: number
  animate?: boolean
}

const angles = [2, 3, -2, -3]

export default function UIText({ is, i18nKey, delay, className, animate = true }: UITextProps) {
  const { gsap, SplitText } = useGSAP()
  const { components } = useTransComponents()
  const Component = is

  const elementRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      new SplitText(elementRef.current, {
        type: 'lines',
        lineThreshold: 0.5,
        linesClass: 'Line',
      })
      new SplitText(elementRef.current, {
        type: 'lines',
        lineThreshold: 0.5,
        linesClass: 'Line__Parent overflow-hidden py-12 -my-24',
      })

      const timeline = gsap.timeline({ delay })
      if (!animate) return
      const lines = elementRef.current.querySelectorAll('.Line')
      if (lines.length > 0) {
        timeline.fromTo(
          lines,
          {
            yPercent: 130,
          },
          {
            yPercent: 0,
            duration: 0.7,
            stagger: {
              amount: 0.3,
            },
            ease: 'back.out(1.7)',
          },
          0
        )

        const gap = 0.3 / lines.length
      }
    })
    return () => ctx.revert()
  }, [delay, elementRef, gsap, SplitText])

  return (
    <Component
      // Dynamic tag name makes ref types incompatible; runtime behavior is correct.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ref={elementRef as any}
      className={`${className ? className : ''} py-12`}
    >
      <Trans i18nKey={i18nKey} components={components} />
    </Component>
  )
}
